import { momentItems } from '../../../mocks/entertainment';
import SectionHead from './SectionHead';

export default function Moments() {
  return (
    <section id="moments" className="relative scroll-mt-16 overflow-hidden bg-primary-950 py-16 md:py-24">
      {/* 氛围光 */}
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-accent-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-10 h-80 w-80 rounded-full bg-primary-500/25 blur-3xl" />

      <div className="relative mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHead
            light
            eyebrow="明星名场面合集"
            title="你错过的名场面，都在这里"
            desc="一句接梗、一次愣神、一个转身，都可能成为全网二创的起点。年度人气名场面按讨论热度归档。"
          />
          <div className="flex items-center gap-2">
            {['采访', '综艺', '红毯', '舞台'].map((t) => (
              <span
                key={t}
                className="rounded-full border border-background-50/20 bg-background-50/5 px-3 py-1.5 text-xs text-background-100/90"
              >
                #{t}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5">
          {momentItems.map((m) => (
            <figure key={m.title} className="group relative overflow-hidden rounded-xl">
              <div className="aspect-[3/4] w-full overflow-hidden">
                <img
                  src={m.img}
                  alt={`名场面配图：${m.title}`}
                  title={m.title}
                  className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-950">
                {m.tag}
              </span>
              <figcaption className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <h3 className="text-sm font-bold leading-snug text-background-50 md:text-base">{m.title}</h3>
                <p className="mt-1.5 hidden text-xs leading-relaxed text-background-100/80 sm:block">{m.caption}</p>
                <div className="mt-2 flex items-center gap-1.5 text-xs text-accent-400">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  人气名场面
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-background-100/60">
          名场面均为对公开讨论内容的趣味盘点，含戏谑成分，请理性看待，不作真实定论。
        </p>
      </div>
    </section>
  );
}